/**
 * Service module for the Feeds entity
 * @module FeedService
 *
 * This module contains all requests regarding all actions of the Feed of a lead
 */
import { CrmAxios } from '@/config/axios';

/**
 * Sends the message to the receiver's feed
 * @param {string} id Identifier for the receiver's id
 * @param {object} data Represents the message that will be sent to the feed
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object with the response of the POST request
 */
export function sendMessageByReceiverId(id, data, config = {}) {
  return CrmAxios.post(`/receivers/${id}/messages`, data, config);
}

/**
 * get the status of a feed message by visitorId and engagement type
 * @param {string} visitorId identifier of the visitor
 * @param {string} receiverId  identifier of the receiver
 * @param {string} engagementType type of engagement eg. 'trade-walk'
 * @returns
 */
export function getEngagementStatus(visitorId, receiverId, engagementType) {
  return CrmAxios.get(`engagements/${visitorId}/receivers/${receiverId}?type=${engagementType}`);
}

/**
 *
 * @param {string} visitorId identifier of the visitor
 * @param {string} leadId UUID of the lead
 * @param {string} engagementType type of the engagement eg. 'trade-walk'
 * @param {File} file The file to upload
 * @returns {Promise}
 */
export function addEngagementFile(visitorId, leadId, engagementType, file) {
  const data = new FormData();
  data.append('file', file);
  data.append('visitor_id', visitorId);
  data.append('verb', engagementType);
  return CrmAxios.post(`filesystem_external/${leadId}/leads`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

/**
 *
 * @param {string} visitorId identifier of the visitor
 * @param {string} leadId UUID of the lead
 * @param {string} engagementType type of the engagement eg. 'trade-walk'
 * @param {File[]} files The files to upload
 * @returns {Promise}
 */
export function addEngagementFiles(visitorId, leadId, engagementType, files) {
  const filesRequests = files.map((file) => {
    return addEngagementFile(visitorId, leadId, engagementType, file);
  });
  return Promise.allSettled(filesRequests);
}

export default {
  sendMessageByReceiverId,
  getEngagementStatus,
  addEngagementFiles,
};
